import { QueryClientConfig } from '@tanstack/react-query';


export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 360000, // 6 minutes
    },
  },
};
